'use client'

import ProfileAvatar from '@/app/[locale]/(worlds)/profile/components/ProfileAvatar'
import OmniDialog from '@/components/OmniDialog'
import ViverseButton from '@/components/ViverseButton'
import { PROFILE_SEARCH_PARAM_KEYS } from '@/constants/profile'
import defaultHeadIcon from '@/public/images/creator-intro/avatar-2.png'
import { UserProfile } from '@/services/cms'
import { useTranslations } from 'next-intl'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import { useState } from 'react'

type PremiumWelcomeDialogProps = {
  userProfile: Partial<UserProfile>
  openDialog?: boolean
}

function PremiumWelcomeDialog({ userProfile, openDialog }: PremiumWelcomeDialogProps) {
  const t = useTranslations()
  const [isDialogOpen, setIsDialogOpen] = useState(!!openDialog)
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  if (!isDialogOpen) return null

  const { display_name: displayName, active_avatar: activeAvatar } = userProfile

  const handleClose = () => {
    setIsDialogOpen(false)
    const params = new URLSearchParams(searchParams.toString())
    params.delete(PROFILE_SEARCH_PARAM_KEYS.OPEN_PREMIUM_WELCOME_DIALOG)
    router.replace(`${pathname}?${params.toString()}#premium`)
  }

  return (
    <OmniDialog
      contentClassName="max-w-[320px] flex flex-col min-h-[216px] w-full md:max-w-[640px] border-0 overflow-visible pt-[66px] md:pt-[34px] focus:outline-none"
      triggerClassName="contents"
      headerClassName="hidden"
      bodyClassName="gap-y-[8px] md:gap-y-[18px]"
      open={isDialogOpen}
      withCloseButton={false}
    >
      <div
        className="bg-vive-brand-50/20 absolute top-0 left-1/2 h-[116px] w-[232px] -translate-x-1/2 rounded-full blur-[35px]"
        aria-hidden="true"
      />
      <div className="absolute top-0 left-1/2 flex -translate-x-1/2 -translate-y-1/2 justify-center">
        <ProfileAvatar
          variant="public"
          avatarUrl={activeAvatar?.head_icon_url || defaultHeadIcon.src}
        />
      </div>

      <span className="text-vive-white header2-omni-styles text-center">Welcome!</span>
      <div className="flex flex-col gap-6 md:gap-8">
        <span className="body1-omni-styles whitespace-pre-line">
          {t('premium-welcome-modal.description', { displayName: displayName ?? '' })}
        </span>
        <ViverseButton className="m-auto md:min-h-[48px] md:text-[18px]" onClick={handleClose}>
          {t('premium-welcome-modal.button-label')}
        </ViverseButton>
      </div>
    </OmniDialog>
  )
}

export default PremiumWelcomeDialog
